import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  SimpleChanges, OnChanges,
} from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { PurchasesQuoteRequestService } from '../../../../core/services/purchases/purchases-quote-request/purchases-quote-request.service'
import {
  ErrorRequestModel,
} from '../../../../core/models/response.model'
import { CnpjPipe } from '../../../../shared/pipes/cpnj.pipes'
import { TelefonePipe } from '../../../../shared/pipes/phone.pipes'
import { JsonPipe } from '@angular/common'
import { PurchasesQuoteRequestItinerariesService } from '../../../../core/services/purchases/purchases-quote-request-itineraries/purchases-quote-request-itineraries.service'
import { MatProgressBar } from '@angular/material/progress-bar'
import { convertCurrency } from '../../../../shared/utils/utils'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { PurchasesQuoteItemSupplierService } from '../../../../core/services/purchases/purchases-quote-item-supplier/purchases-quote-item-supplier.service'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'

@Component({
  selector: 'modal-purchases-supplier-price',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    CnpjPipe,
    TelefonePipe,
    JsonPipe,
    MatProgressBar,
    CurrencyInputDirective,
  ],
  templateUrl: './modal-purchases-supplier-price.component.html',
  styleUrl: './modal-purchases-supplier-price.component.scss',
  providers: [PurchasesQuoteRequestService],
  standalone: true,
})
export class ModalPurchasesSupplierPriceComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private purchasesQuoteRequestItinerariesService: PurchasesQuoteRequestItinerariesService,
    private dialogRef: MatDialogRef<ModalPurchasesSupplierPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
    private purchasesQuoteItemSupplierService: PurchasesQuoteItemSupplierService,
  ) {
    if (data) {
      this.item = data.quote
      this.supplier = data.supplier
      this.proposal = data.proposal
    }
  }

  item: any = {}
  supplier: any = {}
  proposal: any = {}

  form: FormGroup = new FormGroup({})
  loading = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() personId = 0

  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  close() {
    this.dialogRef.close()
  }

  private treatmentItem() {
    this.form.reset()
    this.fillForm()
  }

  fillForm() {
    this.form.get('origin')?.setValue(this.item.origem)
    this.form.get('destination')?.setValue(this.item.destino)
    this.form.get('serviceType')?.setValue(this.item.tipoServico)
    this.form.get('service')?.setValue(this.item.servico)
    this.form.get('vehicleType')?.setValue(this.item.tipoVeiculo)
    this.form.get('driverType')?.setValue(this.item.tipoMotorista)
    this.form.get('dateStart')?.setValue(this.item.itemDataInicio)
    this.form.get('dateFinal')?.setValue(this.item.itemDataFinal)
    this.form
      .get('cost')
      ?.setValue(
        this.supplier.custo != '' ? convertCurrency(this.supplier.custo) : '',
      )
    this.form
      .get('costKmExtra')
      ?.setValue(
        this.supplier.custoKmExtra != ''
          ? convertCurrency(this.supplier.custoKmExtra)
          : '',
      )
    this.form
      .get('costOvertime')
      ?.setValue(
        this.supplier.custoHoraExtra != ''
          ? convertCurrency(this.supplier.custoHoraExtra)
          : '',
      )
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      origin: [''],
      destination: [''],
      serviceType: [''],
      service: [''],
      vehicleType: [''],
      driverType: [''],
      dateStart: [''],
      dateFinal: [''],
      cost: ['', Validators.required],
      costKmExtra: ['', Validators.required],
      costOvertime: ['', Validators.required],
    })
    this.form.get('origin')?.disable()
    this.form.get('destination')?.disable()
    this.form.get('serviceType')?.disable()
    this.form.get('service')?.disable()
    this.form.get('vehicleType')?.disable()
    this.form.get('driverType')?.disable()
    this.form.get('dateStart')?.disable()
    this.form.get('dateFinal')?.disable()
    this.fillForm()
  }

  editItemPurchases() {
    this.loading = true
    const model = this.createModel()
    this.purchasesQuoteItemSupplierService
      .editPurchasesQuoteItemSupplier(model)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.response.emit(true)
          this.close()
          this.loading = false
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel() {
    const cost = this.form.get('cost')?.value
    const costKm = this.form.get('costKmExtra')?.value
    const costOvertime = this.form.get('costOvertime')?.value
    return {
      statusId: 2,
      id: this.supplier.id,
      cotacaoId: this.supplier.cotacaoId,
      propostaItemId: this.item.propostaItemId,
      solicitacaoId: this.supplier.solicitacaoId,
      custo: convertCurrency(cost),
      custoHoraExtra: convertCurrency(costOvertime),
      custoKmExtra: convertCurrency(costKm),
    }
  }
}
